import { defineStore } from "pinia";

export const useCallCenterStore = defineStore("callCenter", {
  state: () => ({
    callCenterStep: 1,
    isChangePage: false,
    isDisabledOrder: false,
    isOrderShow: false,
    isDeliveryShow: false,
    isInvoiceShow: false,
    isSummaryShow: false,
    refreshList: false,
    badge: 10,
    minOrderPrice: 1437,
    isOrderStatusChange: 0,
    paymentMethods: [
      {
        text: "Online",
        value: "ONL",
      },
      {
        text: "Havale / EFT",
        value: "HAVALE",
      },
      {
        text: "Kapıda Kredi Kartı",
        value: "CCKAPIDA",
      },
      {
        text: "Kapıda Nakit",
        value: "CASHKAPIDA",
      },
    ],
    invaddreinvTypes: [
      {
        text: "E-Arşiv",
        value: "EARSIV",
      },
      {
        text: "E-Fatura",
        value: "EFATURA",
      },
    ],
    data: {
      customer: {
        name: "",
        surname: "",
        tel: "",
        email: "",
        referral: "callCenter",
      },
      products: [],
      baskets: [],
      delivery: {
        deliverydate: "",
        deliveryhour: "",
        paymenttype: "",
        customer: "",
        customertxt: "",
        officename: "",
        city: "",
        state: "",
        address: "",
        notes: "",
        needinvoice: false,
        isdifferentinvoiceaddr: false,
      },
      invoice: {
        invaddrname: "",
        invaddrsurname: "",
        invaddrcompname: "",
        invaddrvatno: "",
        invaddrtaxtdept: "",
        invaddreinvtype: "",
        invaddrtel: "",
        invaddremail: "",
        invaddrcity: "",
        invaddrstate: "",
        invaddr: "",
      },
    },
  }),
  getters: {
    fullname() {
      return this.data.customer.name + " " + this.data.customer.surname;
    },
    phone() {
      return this.data.customer.tel;
    },
    email() {
      return this.data.customer.email;
    },
    address() {
      let result =
        this.data.delivery.address +
        " " +
        this.data.delivery.state +
        " / " +
        this.data.delivery.city.il;
      return result;
    },
    totalProducts() {
      return this.data.products.length;
    },
    packageProducts() {
      return this.data.products.reduce((total, item) => total + item.quantity, 0);
    },
    sumProductsPrice() {
      return this.data.products.reduce(
        (total, item) => total + item.quantity * item.satis_fiyati,
        0
      );
    },
    deliveryDate() {
      return this.data.delivery.deliverydate;
    },

    deliveryHour() {
      return this.data.delivery.deliveryhour;
    },

    deliveryCustomer() {
      return this.data.delivery.customer.text || this.data.delivery.officename;
    },
    deliveryNote() {
      return this.data.delivery.notes;
    },
    paymentType() {
      let result = "";
      const paymentType = this.paymentMethods.find(
        (item) => item.value === this.data.delivery.paymenttype
      );
      if (paymentType) {
        result = paymentType.text;
      }
      return result;
    },

    invoiceType() {
      let result = "";
      const invoiceType = this.invaddreinvTypes.find(
        (item) => item.value === this.data.invoice.invaddreinvtype
      );
      if (invoiceType) {
        result = invoiceType.text;
      }
      return result;
    },
    invoiceFullname() {
      return this.data.invoice.invaddrname + " " + this.data.invoice.invaddrsurname;
    },
    invoiceCompany() {
      return this.data.invoice.invaddrcompname;
    },
    invoiceTax() {
      return this.data.invoice.invaddrtaxtdept;
    },
    invoiceVat() {
      return this.data.invoice.invaddrvatno;
    },

    invoiceName() {
      return (
        this.data.invoice.invaddrcompname ||
        this.data.invoice.invaddrname + " " + this.data.invoice.invaddrsurname
      );
    },
    invoicePhone() {
      return this.data.invoice.invaddrtel;
    },
    invoiceMail() {
      return this.data.invoice.invaddremail;
    },
    invoiceAddress() {
      let result =
        this.data.invoice.invaddr +
        " " +
        this.data.invoice.invaddrstate +
        " / " +
        this.data.invoice.invaddrcity.il;
      return result;
    },

    productsAdd() {
      const productsObject = {};

      for (const [key, value] of Object.entries(this.data.products)) {
        productsObject[`line[${key}][uid]`] = value.id * 1;
        productsObject[`line[${key}][qty]`] = value.quantity * 1;
      }

      return {
        ...productsObject,
      };
    },
    saveData() {
      return {
        // Customer
        name: this.data.customer.name,
        surname: this.data.customer.surname,
        tel: this.data.customer.tel.replaceAll(" ", ""),
        email: this.data.customer.email,
        referral: this.data.customer.referral,

        // Delivery
        city: this.data.delivery.city.il,
        state: this.data.delivery.state,
        address: this.data.delivery.address,
        deliverydate: this.data.delivery.deliverydate,
        deliveryhour: this.data.delivery.deliveryhour,

        customer: this.data.delivery.customer.value || this.data.delivery.customer,
        paymenttype: this.data.delivery.paymenttype,
        notes: this.data.delivery.notes,
        needinvoice: this.data.delivery.needinvoice,
        isdifferentinvoiceaddr: this.data.delivery.isdifferentinvoiceaddr,

        // Invoice
        invaddrname: this.data.invoice.invaddrname,
        invaddrsurname: this.data.invoice.invaddrsurname,
        invaddrcompname: this.data.invoice.invaddrcompname,
        invaddrvatno: this.data.invoice.invaddrvatno,
        invaddrtaxtdept: this.data.invoice.invaddrtaxtdept,
        invaddreinvtype: this.data.invoice.invaddreinvtype,
        invaddrtel: this.data.invoice.invaddrtel.replaceAll(" ", ""),
        invaddremail: this.data.invoice.invaddremail,
        invaddrcity: this.data.invoice.invaddrcity.il,
        invaddrstate: this.data.invoice.invaddrstate,
        invaddr: this.data.invoice.invaddr,

        // Products
        ...this.productsAdd,
      };
    },
  },
  actions: {
    increment() {
      this.callCenterStep++;
    },
    decrease() {
      this.callCenterStep--;
    },
  },
});
